<template>
  <cs-preloader-overlay :loading="loading">
    <div class="overlay-container" :class="overlayClass">
      <div class="main-container">
        <div v-if="isShownTitle" class="title-container">
          <capusta-title route-back="login" />
        </div>
        <two-factor-auth-content :content="currentState" />
      </div>
    </div>
  </cs-preloader-overlay>
</template>

<script>
import { getQueryParamsAsObject } from 'lib/utils/url';

import Auth from '@/services/auth';
import HTTPService from '@/services/Http';

import logrocket from '@/services/logrocket';

import CapustaTitle from 'modules/CapustaLayout/CapustaTitle';
import TwoFactorAuthContent from '@/pages/2fa/components/TwoFactorAuthContent';

export default {
  name: 'EmailConfirmation',
  components: {
    CapustaTitle,
    TwoFactorAuthContent,
  },
  head: {
    script: [
      {
        inner: '(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");ym(56244937, "init", {clickmap:true,trackLinks:true,accurateTrackBounce:true,webvisor:true});',
        type: 'text/javascript',
      },
      {
        inner: '!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version="2.0";n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,"script","https://connect.facebook.net/en_US/fbevents.js");fbq("init", "1175137569342493");fbq("track", "PageView");',
        type: 'text/javascript',
      },
      {
        inner: '(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({"gtm.start": new Date().getTime(),event:"gtm.js"});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!="dataLayer"?"&l="+l:"";j.async=true;j.src="https://www.googletagmanager.com/gtm.js?id="+i+dl;f.parentNode.insertBefore(j,f);})(window,document,"script","dataLayer","GTM-WKBLDC4");',
        type: 'text/javascript',
      },
    ],
    noscript: [
      {
        inner: '<div><img src="https://mc.yandex.ru/watch/56244937" style="position:absolute; left:-9999px;" alt="" /></div>"/>',
      },
      {
        inner: '<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WKBLDC4" height="0" width="0" style="display:none;visibility:hidden"></iframe>',
      },
    ],
  },
  created() {
    this.emailConfirmation();
  },
  data() {
    return {
      loading: false,
      currentScreen: 'send',
      dataState: {
        send: {
          title: this.$t('confirm.yourself'),
          body: this.$t('sent.link.to.login'),
          icon: 'send',
          image: 'restore',
        },
        success: {
          title: this.$t('login.confirmed'),
          body: this.$t('personal.account.open.now'),
          icon: 'success',
          image: 'success',
          loading: true,
        },
        error: {
          title: this.$t('authorisation.error'),
          body: '',
          icon: 'danger',
          image: 'error',
          button: '',
        },
      },
    };
  },
  computed: {
    currentState() {
      return this.dataState[this.currentScreen];
    },
    overlayClass() {
      return this.currentScreen === 'error' ? 'overlay-danger' : 'overlay-primary';
    },
    isShownTitle() {
      return this.currentScreen === 'error';
    },
  },
  methods: {
    async emailConfirmation() {
      const GET_PARAMS = ['projectCode', 'token'];

      const rawString = window.location.href.split('?').slice(1);
      const preparedMap = getQueryParamsAsObject(decodeURIComponent(rawString));
      const filteredParams = Object.keys(preparedMap).filter(parameter => GET_PARAMS.includes(parameter));

      const preparedParams = filteredParams.reduce((acc, curr) => {
        acc[curr] = preparedMap[curr] !== 'undefined' ? preparedMap[curr] : '';
        return acc;
      }, {});

      if (!this.$validate.isObjectWithFields(preparedParams, GET_PARAMS)) {
        this.currentScreen = 'send';
        return;
      }

      const payload = {
        projectCode: preparedParams.projectCode,
        token: preparedParams.token,
      };

      this.loading = true;

      try {
        const { data } = await HTTPService.emailConfirmation(payload);
        this.currentScreen = 'success';

        // eslint-disable-next-line no-undef
        fbq('track', 'CompleteRegistration');
        // eslint-disable-next-line no-undef
        ym(56244937, 'reachGoal', 'CompleteRegistration');

        await Auth.refreshToken(data.token);

        setTimeout(() => {
          this.$router.push({
            name: 'cabinet',
            query: {
              token: data.token,
            },
          });
        }, 2000);
      } catch (error) {
        this.currentScreen = 'error';

        logrocket.logger(error);
      }

      this.loading = false;
    },
  },
};
</script>

<style lang="sass" scoped>
  h3
    font-size: 24px
    font-weight: 500
    line-height: 29px
    margin-bottom: 15px
    white-space: nowrap

  p
    opacity: 0.75
    font-weight: 500
    font-size: 14px
    line-height: 20px

  .overlay-container
    width: 100%
    min-height: 100vh

    display: flex
    flex-flow: column
    align-items: center
    justify-content: center
    overflow: hidden

    @media screen and (orientation: landscape) and (max-height: 480px)
      height: auto

  .overlay-primary
    background: linear-gradient(45deg, #24A84D -8.32%, #068ACC 108.85%), rgba(255, 255, 255, 0.5)

  .overlay-danger
    background: #FF5172

  .main-container
    min-width: 460px
    position: relative
    display: flex
    flex-direction: column
    justify-content: center
    padding: 20px 0

    +respond-to('medium')
      flex-direction: row

  .title-container
    position: fixed
    top: 20px
    left: 20px

    +respond-to('medium')
      position: absolute
      left: -40px
      top: 20%
</style>
